'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CalendarWidget from '../Widgets/CalendarWidget.react';
import { getMealTypesForDate } from '../../utils/Meals';

import Modal from 'react-modal';

import '../../pro/components/Modals/Modals.scss';
import './SchedulingModal.scss';

export default class SchedulingModal extends Component {
    static propTypes = {
        initialDate: PropTypes.any,
        isLocked: PropTypes.bool,
        closeModal: PropTypes.func,
        selectDate: PropTypes.func,
        profile: PropTypes.object,
        plans: PropTypes.array,
    };

    static defaultProps = {
        isLocked: false,
        isMealModal: false,
        plans: [],
    };

    static contextTypes = {
        confirm: PropTypes.func,
    }

    constructor(props) {
        super(props);

        const { content, isMealModal, profile, plans } = props;
        const initialDate = props.initialDate ? moment(props.initialDate) : moment();
        const mealTypes = getMealTypesForDate(initialDate, plans, profile?.preferences?.meal_types || []);

        this.state = {
            date: initialDate,
            mealType: isMealModal && content?.meal ? content.meal : this.getDefaultMealTypeFromTags(content?.tags || [], mealTypes),
        };
    }

    getDefaultMealTypeFromTags(contentTags = [], availableMealTypes = []) {
        // Find the first meal type whose main_dish or side_dish matches any content tag
        for (const mealType of availableMealTypes) {
            const mainDishMatch = contentTags.includes(mealType.main_dish);
            const sideDishMatch = contentTags.includes(mealType.side_dish);

            if (mainDishMatch || sideDishMatch) {
                return mealType.name;
            }
        }

        return 'Dinner';
    }

    onChangeDate = (date) => {
        this.setState({date: moment(date)});
    }

    selectDate = () => {
        const { confirm } = this.context;
        const { selectDate, closeModal } = this.props;
        const { date, mealType } = this.state;

        selectDate && selectDate(date, mealType) && closeModal && closeModal();
    }

    render() {
        const { date, mealType } = this.state;
        const { closeModal, isLocked, meal, profile, plans } = this.props;

        const mealTypes = getMealTypesForDate(date, plans, profile?.preferences?.meal_types || []);
        
        const mealTypeOptions = mealTypes.map(mt => ({
            name: mt.name,
            displayName: mt.custom_name || mt.name
        }));

        return (
            <Modal isOpen={true}
                onRequestClose={closeModal}
                closeModal={closeModal}
                className="el-modal el-modal2"
                overlayClassName="el-modal-overlay"
                contentLabel="Choose a date"
                closeTimeoutMS={250}>

                <div className="el-modal-container el-modal2-container">
                    <header>
                        <h2>When would you like to have this meal?</h2>

                        <button className="el-modal-close-x" onClick={closeModal}>
                            <i className="icon-close-x" />
                            <span className="assistive-text">Close Modal</span>
                        </button>
                    </header>

                    <div className="el-modal-body-container el-modal2-body-container el-fonts">
                        <CalendarWidget
                            value={date.toDate()}
                            onChange={this.onChangeDate} />

                        <section className="meal-type-radio">
                            <label>Designate this meal as:</label>
                            <div className={"meal-type-buttons"}>
                                {mealTypeOptions.map(mt => (
                                    <button 
                                        key={mt.name} 
                                        className={mealType === mt.name ? "active" : ""} 
                                        onClick={() => this.setState({mealType: mt.name})}>
                                        {mt.displayName}
                                    </button>
                                ))}
                            </div>
                        </section>
                    </div>

                    <footer>
                        <button className="el-modal-cancel-btn el-small-btn" onClick={closeModal}>cancel</button>
                        <button className="el-modal-ok-btn el-small-btn" onClick={this.selectDate}>Add to Schedule {isLocked ? <i className="icon-lock" /> : null}</button>
                    </footer>
                </div>
            </Modal>
        );
    }
}
